import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("jk_token", data.token);
      localStorage.setItem("jk_user", JSON.stringify(data.user));
      toast.success("Welcome back");
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Login failed";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-brand-forest flex items-center justify-center p-6"
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-grid h-12 w-12 place-items-center rounded-md bg-brand-gold text-brand-forest font-bold mb-4">
            JK
          </div>
          <h1 className="font-heading text-3xl font-bold text-brand-cream">
            Admin Portal
          </h1>
          <p className="text-sm text-brand-cream/60 mt-2">
            Sign in to manage leads
          </p>
        </div>

        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="bg-brand-cream rounded-md p-8 space-y-5"
        >
          <div>
            <label className="text-sm font-semibold text-brand-forest">
              Email
            </label>
            <input
              type="email"
              required
              data-testid="login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full h-12 px-3 rounded-md border border-brand-line bg-white text-sm focus:outline-none focus:ring-2 focus:ring-brand-forest"
              placeholder="admin@jkawesomedeeds.com"
            />
          </div>
          <div>
            <label className="text-sm font-semibold text-brand-forest">
              Password
            </label>
            <input
              type="password"
              required
              data-testid="login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full h-12 px-3 rounded-md border border-brand-line bg-white text-sm focus:outline-none focus:ring-2 focus:ring-brand-forest"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            data-testid="login-submit"
            disabled={loading}
            className="btn-primary w-full"
          >
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" /> Signing in...
              </>
            ) : (
              <>
                <Lock className="h-4 w-4" /> Sign In
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
